<template>
    <v-dialog-old
        @hidden="cancelGlueClinic"
        :onCloseEsc="cancelGlueClinic"
        ref="mainGlueDialog"
        class="glue"
        :special-styles="{ width: '1800px' }"
    >
        <fieldset v-if="!clinisForMerge.length" class="glue__url-input">
            <legend>
                <span>Объединение клиник</span>
                <!-- <a class="glue__title" @click="toggleManualMerge">{{ title }}</a>
                TODO: Скрыть возможность автоматической склейки.
                 https://youtrack.doctu.ru/issue/doctu-3771/Konkurenty-pri-sklejke-klinik
                -->
            </legend>
            <div v-if="manualMerge">
                <label>URL откуда</label>
                <input v-model="url.first">
                <label>URL куда</label>
                <input v-model="url.second">
            </div>
<!--            <div v-else>-->
<!--                <AutoMergeSummary-->
<!--                    v-if="isAutoMergeResponse"-->
<!--                    :errors="autoMergeSummary.errors"-->
<!--                    :success-count="autoMergeSummary.success_count"-->
<!--                    :errors-count="autoMergeSummary.errors_count"-->
<!--                />-->
<!--                <textarea v-if="!isAutoMergeResponse" v-model="automMergeField" rows="10"></textarea>-->
<!--            </div>-->

            <div class="glue__button">
                <button v-if="manualMerge" @click="getClinics" :class="[loadingClass]">
                    <span>Объединить</span>
                </button>
<!--                <button :disabled="automMergeField === ''" v-if="!manualMerge && !isAutoMergeResponse" @click="autoGlue" :class="[loadingClass]">-->
<!--                    <span>Склеить автоматически</span>-->
<!--                </button>-->
            </div>
        </fieldset>
        <ValidationObserver ref="modCompare">
            <mod-compare
                v-if="clinisForMerge.length"
                ref="compare"
                @emit-coords="setCoords"
                class="glue__compare"
                :o="oldClinic" :n="newClinic" :f.sync="resultClinic"
                :options="modOptionsTest" :blocks="modBlocks"
                :main-title="clinicTitle"
                :competitors="competitors"
                :competitor-urls-conflicts="competitorUrlsConflicts"
                :resolved-urls-conflict="competitorUrlsConflictResolved"
                @url-conflicts-resolved="resolveCompetitorUrlsConflict"
            >
                <label>
                    <input type="checkbox" v-model="mergeDoctors">
                    <span>Объединить врачей</span>
                </label>
            </mod-compare>
        </ValidationObserver>
        <div v-if="clinisForMerge.length" class="glue__approve">
            <button @click="saveResultClinic" class="glue__approve--save green">
                <span>Сохранить</span>
            </button>
            <button @click="cancelGlueClinic">
                <span>Отменить</span>
            </button>
        </div>
    </v-dialog-old>
</template>

<script>
import { modBlocks, modDefault, modOptions } from "@dialogs/admin/clinics/clinicMerge/ClinicMergeFields";
    import AutoMergeSummary from "./AutoMergeSummary"
    import ModCompare from "@components/common/modCompare/ModCompare"

    export default {
        name: "GlueClinicDialog",
        props: {
            competitors: Array
        },
        components: {
            ModCompare,
            AutoMergeSummary,
        },
        data: () => ({
            url: {
                first: '',
                second: '',
            },

            oldClinic: modDefault(),
            newClinic: modDefault(),
            resultClinic: modDefault(),
            modOptionsTest: modOptions(),
            competitorUrlsConflicts: [],
            selectedCompetitorUrls: [],
            clinisForMerge: [],
            loadingClass: false,
            additionalFields: [],
            modBlocks: modBlocks,
            manualMerge: true,
            // isAutoMergeResponse: false,
            // autoMergeSummary: {
            //     errors: [],
            //     success_count: 0,
            //     errors_count: 0,
            // },
            // automMergeField: '',
        }),
        methods: {
            showMainFrame() {
                this.$refs.mainGlueDialog.show();
            },
            setCoords(data) {
                this.resultClinic.markLat  = data.lat;
                this.resultClinic.markLong = data.long;
                this.resultClinic.mapZoom  = data.zoom;
            },
            getClinics() {
                this.axios.get(`/admin/clinics/glue?firstUrl=${this.url.first}&secondUrl=${this.url.second}`)
                    .then((res) => {
                        this.oldClinic = Object.assign(this.oldClinic, res.data[0]);
                        this.newClinic = Object.assign(this.newClinic, res.data[1]);
                        this.resultClinic = Object.assign(this.resultClinic, res.data[2]);
                        this.competitorUrlsConflicts = res.data[3]
                        this.setAdditionalfields();
                        this.clinisForMerge = res.data;
                        this.modOptions.find(item => item.key === 'locality').filter.city = this.resultClinic.city
                        this.modOptions.find(item => item.key === 'district').filter.city = this.resultClinic.city
                        this.modOptions.find(item => item.key === 'area').filter.city = this.resultClinic.city
                    });
            },
            // TODO: Скрыть возможность автоматической склейки. https://youtrack.doctu.ru/issue/doctu-3771/Konkurenty-pri-sklejke-klinik
            // async autoGlue() {
            //     let res = await this.axios.post('/admin/clinics/glue/auto', {
            //         urls: this.automMergeField
            //     });
            //
            //     this.isAutoMergeResponse = true;
            //     this.autoMergeSummary = Object.assign({}, res.data);
            // },
            setAdditionalfields() {
                this.axios.get('/admin/clinics/glue/additional-fields')
                    .then((res) => {
                        this.additionalFields = res.data;
                    });
            },
            toggleDoctorsMerge() {
                this.$store.commit('glueClinics/toggleDoctorsMerge')
            },
            // toggleManualMerge() {
            //     this.manualMerge = !this.manualMerge;
            // },
            resolveCompetitorUrlsConflict(urls) {
                this.selectedCompetitorUrls = urls
            },
            saveResultClinic() {
                try {
                    this.$refs.modCompare.validate().then(success => {
                        if (!success) {
                            const el = document.querySelector(".hasError:first-of-type");
                            if (el) {
                                el.scrollIntoView({behavior: "smooth"});
                            }
                            return;
                        }
                        this.axios.post('/admin/clinics/glue', {
                            clinic: this.resultClinic,
                            firstUrl: this.url.first,
                            secondUrl: this.url.second,
                            specialData: {
                                mergeDoctors: this.mergeDoctors
                            },
                            competitorUrlsConflict: this.selectedCompetitorUrls
                        }).then(()=>{
                            this.fireUpdatedEvent();
                            this.cancelGlueClinic();
                            this.$refs.mainGlueDialog.hide();
                        })
                    });

                } catch (e) {

                }
            },
            fireUpdatedEvent: function () {
                this.$emit('updated');
                this.$bus.fire('updateMenu');
            },
            async cancelGlueClinic() {
                this.result = {};
                this.clinisForMerge = [];
                this.url.first = '';
                this.url.second = '';
                this.automMergeField = '';
                this.isAutoMergeResponse = false;
                this.$store.state.glueClinics.doctorsMerge = true;
            },
        },
        //TODO разобраться как этим управлять
        computed: {
            clinicTitle() {
                return `<a target="_blank" href="${this.url.second}">${this.url.second}</a>`
            },
            modOptions() {
                return modOptions().concat(this.additionalFields);
            },
            title() {
                return this.manualMerge ? 'ручное' : 'авто'
            },
            competitorUrlsConflictResolved() {
                //for validation... feels like a stupid hack, but works
                if (
                    this.competitorUrlsConflicts.length === 0
                    || this.competitorUrlsConflicts.length === this.selectedCompetitorUrls.length
                ) {
                    return 'resolved'
                }

                return ''
            },
            mergeDoctors: {
                get() {
                    return this.$store.state.glueClinics.doctorsMerge
                },
                set(value) {
                    this.$store.commit('glueClinics/toggleDoctorsMerge')
                }

            }
        },
    }
</script>

<style lang="scss">
    .glue {
        &__button {
            margin-top: 1rem;
        }
        &__approve {
            margin-top: 1rem;
            display: flex;
            justify-content: center;
            &--save {
                margin-right: 1rem;
            }
        }
        &__title {
            color: #0E5E85;
        }
    }
</style>
